module.exports = __webpack_public_path__ + "img/consciusIcon_BRAK.dce39385.jpg";